import { GROUP_ID } from "@/constant/group";
import { moimAPI } from ".";

export async function fetchGroupTheme() {
  return (
    await moimAPI.request<Moim.ISingleItemResponse<Moim.Group.ITheme>>({
      method: "GET",
      url: `/v2/groups/${GROUP_ID}/theme`,
    })
  ).data;
}

export async function fetchThread(threadId: string) {
  return (
    await moimAPI.request<Moim.ISingleItemResponse<Moim.Forum.IThread>>({
      method: "GET",
      url: `/threads/${threadId}`,
    })
  ).data;
}

export async function postReply(
  forumId: string,
  threadId: string,
  content: Moim.Blockit.Blocks[],
) {
  return (
    await moimAPI.request<Moim.ISingleItemResponse<Moim.Forum.IThread>>({
      method: "POST",
      url: `/forums/${forumId}/threads/${threadId}/replies`,
      data: {
        reply: {
          type: "nestedReply",
          content,
        },
      },
    })
  ).data;
}

export async function fetchCalendarEvents(payload: {
  startAt: number;
  endAt: number;
  tagIds?: Moim.Id[];
  templateId?: Moim.Id;
}) {
  const { startAt, endAt, tagIds, templateId } = payload;
  return await moimAPI.request<
    Moim.IPaginatedListResponse<Moim.Blockit.V2.Calendar.IEvent>
  >({
    method: "POST",
    url: `/v3/events/search`,
    data: {
      query: {
        startAt,
        endAt,
        tagIds,
      },
      templateId,
    },
  });
}

export async function fetchChannel(request: Moim.Channel.IGetChannelRequest) {
  return (
    await moimAPI.request<Moim.Channel.IGetChannelResponseBody>({
      method: "GET",
      url: `/channels/${request.channelId}`,
      params: {
        includePrefetchedData: request.includePrefetchedData
          ? "true"
          : undefined,
      },
    })
  ).data;
}

//#region USER API

export async function updateProfile(profile: Moim.User.IUpdatableInfo) {
  return (
    await moimAPI.request<
      Moim.ISingleItemResponse<Moim.User.IOriginalUserDatum>
    >({
      method: "PUT",
      url: "/me",
      data: { profile },
    })
  ).data;
}

export async function fetchProfile() {
  return (
    await moimAPI.request<
      Moim.ISingleItemResponse<Moim.User.IOriginalUserDatum>
    >({ method: "GET", url: "/me" })
  ).data;
}

//#endregion
